export  const groupBy = <T>(array: T[], key: string) => {
  return array.reduce(function(rv : {[key: string]: T[]}, x:any) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};